/**
 * Backward-compatible AI service.
 *
 * The public API is unchanged — `analyzePropertyDescription(property)` and
 * `compareProperties(target, similar)` still resolve to Markdown strings — but
 * calls now route through the AI proxy worker, which resolves the user's
 * selected provider/model and key server-side. No provider key lives in the
 * browser anymore.
 *
 * Provider/model selection and the user's API key are managed in the AI
 * settings UI (see useAIConfig); this module just forwards the request.
 */

import { aiProxy } from './ai/proxyClient';

export const analyzePropertyDescription = async (property) => {
  const result = await aiProxy.analyzeProperty(property);
  return result.text;
};

export const compareProperties = async (targetProperty, similarProperties) => {
  const result = await aiProxy.compareProperties(targetProperty, similarProperties);
  return result.text;
};
